import { useCallback, useState } from 'react';

const getAccordionState = (ids, state = false) =>
  Object.keys(ids).reduce((acc, id) => {
    acc[id] = state;
    return acc;
  }, {});

export const useControlledAccordions = ({ fieldIds }) => {
  const [accordionsState, setAccordionStates] = useState(getAccordionState(fieldIds, false));
  const [isAllExpanded, setIsAllExpanded] = useState(false);

  const onToggleExpandAll = useCallback(() => {
    setAccordionStates(getAccordionState(fieldIds, !isAllExpanded));
    setIsAllExpanded(!isAllExpanded);
  }, [fieldIds, isAllExpanded]);

  const onToggleExpand = useCallback((expanded, id) => {
    setAccordionStates(prev => ({ ...prev, [id]: expanded }));
  }, []);

  return { accordionsState, isAllExpanded, onToggleExpandAll, onToggleExpand };
};
